export default __webpack_public_path__ + "static/media/home.e9d546d0.svg";